module.exports = __webpack_public_path__ + "static/media/progress.89f641bc.svg";